<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <div class="section">
        <div class="section-header"><h3>납부정보</h3></div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              <label for="customer-type-confirmed">납부정보</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p id="customer-type-confirmed" class="data-text">
                  {{ paymMthdDivsNm }}
                  <span v-if="registration.paymMthdDivsCd === 'B'">
                    ) {{ registration.bankNm }}
                    {{ registration.acctCardNoMask }}
                  </span>
                  <span v-if="registration.paymMthdDivsCd === 'C'">
                    ) {{ registration.CdcoNm }}
                    {{ registration.acctCardNoMask }}
                    <span> (유효기간 ****/**)</span>
                  </span>
                </p>
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              <label for="customer-name-confirmed">출금결제동의</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p id="customer-name-confirmed" class="data-text">
                  출금동의
                </p>
              </div>
              <ul class="notice-text-list">
                <li class="notice-text">
                  본인(예금주 또는 회원)이 납부하여야 할 요금에 대해 별도의 통지
                  없이 상기 본인의 지정계좌(카드번호)에서 지정된 송금(결제)일에
                  인출(결재) 하여 주시기 바랍니다.
                </li>
              </ul>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayInformationSection',
  props: {
    registrationProps: Object
  },
  data() {
    return {
      registration: {}
    }
  },
  mounted() {
    this.registration = this.registrationProps
  },
  computed: {
    paymMthdDivsNm() {
      if (this.registration.paymMthdDivsCd === 'B') return '은행'
      if (this.registration.paymMthdDivsCd === 'C') return '카드'
      if (this.registration.paymMthdDivsCd === 'G') return '지로'
      return ''
    }
  },

  components: {},

  methods: {}
}
</script>

<style scoped></style>
